import { useSelector } from "react-redux";
import { AppState } from "../../../../../../../stateManager/store";
import { data } from "../../data";

type Font = {
  name: string;
}

export const GetFontFamilyList = () => {
  const { gridStyles } = useSelector((state: AppState) => state.formJson)
  const customFontFamily = gridStyles.common?.fontFamily || []
  const urlCreation = (matches: any, val: any) => {
    const words = matches.map((match: any) => {
      const name = match.replace('family=', '').replace(':', '').replace('&', '').replace(/\+/g, ' ').trim();
      return { name }
    })
    return words
  }
  let CustomFontFamilyList: any = [];
  if (customFontFamily && customFontFamily.length > 0) {
    customFontFamily.forEach((val: any) => {
      if (val?.url.endsWith("swap")) {
        if (val?.url.includes("googleapis")) {
          const pattern = /family=.*?(:|&)/g;
          const matches = val?.url.match(pattern);
          if (matches) {
            const fontCollection: any = urlCreation(matches, val);
            const unmatchedObjects = fontCollection.filter((arr: any) => !CustomFontFamilyList.some((font: any) => JSON.stringify(font) === JSON.stringify(arr)));
            CustomFontFamilyList = [...CustomFontFamilyList, ...unmatchedObjects];
          }
        }
      } else {
        CustomFontFamilyList.push(val);
      }
    });
  }

  const userAgent = window.navigator.userAgent.toLowerCase()
  var fontFamilyList: any;
  if (userAgent.match(/Mac/i)) {
    fontFamilyList = data?.fontFamily?.macOS
  } else if (userAgent.match(/Linux/i)) {
    fontFamilyList = data?.fontFamily?.linux;
  } else if (userAgent.match(/Win/i)) {
    fontFamilyList = data?.fontFamily?.windows;
  }

  const optionList: {
    customFonts: Font[],
    systemFonts: Font[],
    staticFonts?: Font[]
  } = {
    "customFonts": CustomFontFamilyList?.length > 0 &&
      CustomFontFamilyList.map((el: any) => ({
        name: el.name,
      })) || [],
    "systemFonts": fontFamilyList
      ? fontFamilyList.map((el: any) => ({
        name: el.label,
      })) : []
  }

  return optionList
}